import r from "./_listCacheClear.js";
import i from "./_listCacheDelete.js";
import h from "./_listCacheGet.js";
import s from "./_listCacheHas.js";
import p from "./_listCacheSet.js";
var c = r, C = i, m = h, f = s, _ = p;
function t(e) {
  var a = -1, o = e == null ? 0 : e.length;
  for (this.clear(); ++a < o; ) {
    var l = e[a];
    this.set(l[0], l[1]);
  }
}
t.prototype.clear = c;
t.prototype.delete = C;
t.prototype.get = m;
t.prototype.has = f;
t.prototype.set = _;
var u = t;
export {
  u as default
};
//# sourceMappingURL=_ListCache.js.map
